import PropTypes from 'prop-types';

export default function NbusLobTable({ data }) {
    const totalItem = data.find(item => item.GroupingKey === "Total");
    const lobData = data.filter(item => item.GroupingKey !== "Total");

    return (
        <div className="table-container">
            <table id="_Table" className="table">
                <thead>
                    <tr key="headers">
                        <th data-sort-method="none">LOB</th>
                        <th className="sort-header">Quote Count</th>
                        <th className="sort-header">New Business Count</th>
                        <th className="sort-header">Closure (Conversion)</th>
                        <th className="sort-header">New Business Written Premium</th>
                        <th className="sort-header">7 Day Attrition</th>
                    </tr>
                </thead>
                <tbody>
                    {lobData.map((item, index) => (
                        <tr key={index}>
                            <td>{item.GroupingKey}</td>
                            <td>{item.Data.Quotes.toLocaleString()}</td>
                            <td>{item.Data.NewBusiness.toLocaleString()}</td>
                            <td>{(item.Data.Conversion * 100).toFixed(2)}%</td>
                            <td>${Math.round(item.Data.BoundPremium).toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 })}</td>
                            <td>{item.Data.Attrition7Day ? `${(item.Data.Attrition7Day * 100).toFixed(2)}%` : "N/A"}</td>
                        </tr>
                    ))}
                </tbody>
                {totalItem && (
                    <tfoot>
                        <tr>
                            <td>{totalItem.GroupingKey}</td>
                            <td>{totalItem.Data.Quotes.toLocaleString()}</td>
                            <td>{totalItem.Data.NewBusiness.toLocaleString()}</td>
                            <td>{(totalItem.Data.Conversion * 100).toFixed(2)}%</td>
                            <td>${totalItem.Data.BoundPremium.toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 })}</td>
                            <td>{totalItem.Data.Attrition7Day ? `${(totalItem.Data.Attrition7Day * 100).toFixed(2)}%` : "N/A"}</td>
                        </tr>
                    </tfoot>
                )}
            </table>
        </div>
    );
}

NbusLobTable.propTypes = {
    data: PropTypes.arrayOf(
        PropTypes.shape({
            GroupingKey: PropTypes.string.isRequired,
            Data: PropTypes.shape({
                Quotes: PropTypes.number.isRequired,
                NewBusiness: PropTypes.number.isRequired,
                Conversion: PropTypes.number.isRequired,
                BoundPremium: PropTypes.number.isRequired,
                Attrition7Day: PropTypes.number
            }).isRequired
        })
    ).isRequired
};